import { DashboardHeader } from '@modules/admin/Admin.Header'
import { getNextRoomId, getPreviousRoomId } from '@modules/admin/rooms/Rooms.dux'

import AccessControl from '@modules/auth/AccessControl'
import Loading from '@modules/core/components/Loading'
import React, { Component } from 'react'
import { Trans } from 'react-i18next'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import Consultations from '@services/Consultations'
import AutomaticTrackingMessage from './messages/AutomaticTrackingMessage'
import Message from './messages/Message'
import RoomHeader from './Room.Show.Header'
import { RoomReview } from './Room.Show.Review'
import './Room.Show.scss'

class RoomShow extends Component {
  roomClient = Consultations.adminRooms

  state = {
    roomId: this.props.match.params.roomId,
    room: undefined,
    messages: [],
    automaticTrackings: [],
  }

  fetchRoom = () => {
    return this.roomClient
      .show(this.state.roomId)
      .then((res) => this.setState({ room: res.data }))
      .catch((err) =>
        this.setState(undefined, () => {
          throw err
        })
      )
  }

  fetchMessages = () => {
    return this.roomClient
      .fetchRoomMessages(this.state.roomId)
      .then((res) => this.setState({ messages: res.data }))
      .catch((err) => {
        window.alert(JSON.stringify(err.message, null, 2))
      })
  }

  fetchTrackings = () => {
    return this.roomClient
      .fetchRoomTrackings(this.state.roomId)
      .then((response) => this.setState({ automaticTrackings: response.data }))
      .catch((err) => {
        window.alert(JSON.stringify(err.message, null, 2))
      })
  }

  componentDidMount() {
    this.fetchMessages()
    this.fetchTrackings()
    this.fetchRoom()
  }

  render() {
    const { messages, room, automaticTrackings } = this.state
    const { previousRoomId, nextRoomId } = this.props

    if (!room) return <Loading isFetching={true} />

    return (
      <div className="container-show-room">
        <DashboardHeader title={`Chat#${room.id}`}>
          <AccessControl requiredRole="super-admin">
            {previousRoomId && (
              <Link className="btn btn-primary" to={`/room/${previousRoomId}`}>
                <Trans>Anterior</Trans>
              </Link>
            )}
            {nextRoomId && (
              <Link className="btn btn-primary" to={`/room/${nextRoomId}`}>
                <Trans>Siguiente</Trans>
              </Link>
            )}
          </AccessControl>

          <Link className="btn btn-primary" to={`/room`}>
            <Trans>Volver</Trans>
          </Link>
        </DashboardHeader>

        <RoomHeader room={room} />

        <div className="chat-review">
          <div className="chat-container comp-chatRoom">
            <div className="body">
              {messages.map((message) => (
                <Message
                  key={message.messageId}
                  message={message}
                  isProfessional={message.fromUserHash === room.professional.hash}
                />
              ))}
              {automaticTrackings.map((tracking) => (
                <AutomaticTrackingMessage tracking={tracking} />
              ))}
            </div>
          </div>

          {room.is_editable && (
            <div className="reviews-container">
              <RoomReview room={this.state.room} />
            </div>
          )}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, props) => ({
  previousRoomId: getPreviousRoomId(state, Number(props.match.params.roomId)),
  nextRoomId: getNextRoomId(state, Number(props.match.params.roomId)),
})

export default connect(mapStateToProps)(RoomShow)
